import { useNavigate } from 'react-router';
import { GridColDef, GridRowParams } from '@mui/x-data-grid';

import {
    DataGrid,
    DataGridCard,
    dataGridNestedObjectValueGetter,
} from '@barboxx/admin-components';
import { ProductAttribute } from '@barboxx/models';

const columns: GridColDef[] = [
    { field: 'id', headerName: 'Id', width: 100 },
    {
        field: 'product.name',
        headerName: 'Name',
        width: 170,
        flex: 1,
        valueGetter: dataGridNestedObjectValueGetter,
    },
    {
        field: 'attributeValue',
        headerName: 'Value',
        width: 130,
        maxWidth: 130,
        align: 'right',
        headerAlign: 'right',
    },
];

interface Props {
    productAttribute: ProductAttribute.DetailsResponse;
    refetch: () => void;
}

export const AttributeValuesCard = ({ productAttribute, refetch }: Props) => {
    const navigate = useNavigate();

    const handleRowClick = (params: GridRowParams) => {
        navigate(`${params.id}`);
    };

    return (
        <DataGridCard title="Product Attribute Values List">
            <DataGrid
                columns={columns}
                disableColumnMenu
                disableRowSelectionOnClick
                paginationMode="client"
                onRowClick={handleRowClick}
                rows={productAttribute.attributeValues}
            />
        </DataGridCard>
    );
};
